module.exports = __webpack_public_path__ + "static/media/wreck.d3c636b9.svg";